/**
 * Indicates if tabs modal for BackBar is open
 * This is a temporary fix for contextual modals in tabs displaying incorrectly
 * in Chrome 52
 *
 * @param {*} state
 * @returns {Boolean}
 */
export const getIsModalActive = (state) => {
  return state.VNTabs?.isModalActive ?? false
}

/**
 * Gets the tab name required flag for starting a tab with custom name
 *
 * @param {*} state
 * @returns {Boolean}
 */
export const getIsTabNameRequired = (state) => {
  return state.VNTabs?.isTabNameRequired ?? false
}
